import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';

export const templateSelectIntegrationType = document.createElement('template');

templateSelectIntegrationType.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="form-wrapper layout-flex-wrap" id="integration-types">
    <gz-integration-type-card class="gz-o365-card"></gz-integration-type-card>
    <gz-integration-type-card class="gz-aws-card"></gz-integration-type-card>
    <gz-integration-type-card class="gz-ad-onprem-card"></gz-integration-type-card>
    <gz-integration-type-card class="gz-azure-ad-card"></gz-integration-type-card>
    <gz-integration-type-card class="gz-nsva-card"></gz-integration-type-card>
    <gz-integration-type-card class="gz-intune-card"></gz-integration-type-card>
    <gz-integration-type-card class="gz-azure-cw-card"></gz-integration-type-card>
    <gz-integration-type-card class="gz-google-workspace-card"></gz-integration-type-card>
    <gz-integration-type-card class="gz-gcp-card"></gz-integration-type-card>
    <gz-integration-type-card class="gz-mobile-security-card"></gz-integration-type-card>
    <gz-integration-type-card class="gz-cloud-security-card"></gz-integration-type-card>
    <gz-integration-type-card class="gz-atlassian-card"></gz-integration-type-card>
    <gz-feedback-card/>
  </div>
`;
